import PropTypes from "prop-types";
import { Col, Row } from "react-bootstrap";
import FormButtonsForCloseAndSubmit from "../../Common/Forms/FormButtonsForCloseAndSubmit";
import FromToDatePickerNative from "../../Common/Forms/FromToDatePickerNative";

const PiggdekkontrollFilterForm = (props) => {
  return (
    <form onSubmit={props.handleSubmit} className="SearchHistorikkForm">
      <div className="searchHistorikkOverskrift">Søk i tabellen</div>
      <div className="filter-flexbox-container piggdekkontroll-filter-flexbox">
        <FromToDatePickerNative
          fra={{
            id: "fraDato",
            name: "fraDato",
            label: "Dato fra",
            placeholder: "Velg dato",
            value: props.piggdekkontrollFilterFormState.fraDato,
            validationError:
              props.piggdekkontrollFilterFormState.fraDatoValidationErrorText,
          }}
          til={{
            id: "tilDato",
            name: "tilDato",
            label: "Dato til",
            placeholder: "Velg dato",
            value: props.piggdekkontrollFilterFormState.tilDato,
            validationError:
              props.piggdekkontrollFilterFormState.tilDatoValidationErrorText,
          }}
          onChange={props.handleChange}
        />
        <div>
          <label htmlFor="kjennemerke">Kjennemerke</label>
          <input
            id="kjennemerke"
            name="kjennemerke"
            className="form-control"
            type="text"
            placeholder="Kjennemerke"
            value={props.piggdekkontrollFilterFormState.kjennemerke}
            onChange={props.handleChange}
          />
        </div>
      </div>
      <Row>
        <Col md={12}>{props.error}</Col>
      </Row>
      <div style={{ height: 20 }} />
      <FormButtonsForCloseAndSubmit
        closeText="Tilbakestill"
        submitText="Søk"
        onClose={props.handleChangeToInitState}
        onSubmit={props.handleSubmit}
        showCloseSpinner={false}
        showSubmitSpinner={props.showSokSpinner}
      />
    </form>
  );
};

PiggdekkontrollFilterForm.propTypes = {
  piggdekkontrollFilterFormState: PropTypes.shape({
    kjennemerke: PropTypes.any,
    fraDato: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    tilDato: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  }),
  handleChange: PropTypes.func,
  handleChangeToInitState: PropTypes.func,
  onSubmit: PropTypes.func,
  showSokSpinner: PropTypes.bool,
};

export default PiggdekkontrollFilterForm;
